import { upperCase as up } from '@/utils'

export default {
  'ja-JP': {
    name: '日本語',
    continent: 'Asia Pacific',

    // Text.
    noMatch: 'マッチするデータなし',
    notFound: '内容が見つかってなかった',
    loading: 'ロード中',
    viewMore: 'もっと見る',
    auth: '認証',
    project: 'ようこそ %{msg} ー Project へ',
    live: 'ライブ',

    // Input field name.
    email: 'Eメールアドレス',
    username: 'アカウント',
    password: 'パスワード',
    logged: '私をログインさせておく',
    enabled: '使用可能',
    disabled: '使用禁止',
    labelName: 'なまえ',
    displayName: '表示名',
    search: '検索',
    status: 'ステータス',
    active: '積極的',
    right: 'ユーザー権限レベル',

    // Menu.
    dashboard: 'ダッシュボード',
    stream: 'ライブストリーム',
    users: 'ユーザーのアクセス許可',
    cog: 'システム構成',
    profile: '私のプロフィール',

    account: 'アカウント',
    permission: 'パーミッション',
    view: 'ビュー',
    camera: 'カメラ',

    business: '企業',
    city: '都市',
    branch: '支部',
    area: 'エリア',

    updated: '最終更新',
    logined: '前回のログイン',
    registered: '登録済み',

    button: {
      signin: 'ログイン',
      signout: 'ログアウト',
      submit: '提出する',
      save: '変更を保存',
      apply: 'アプライ',
      confirm: '確認',
      cancel: 'キャンセル',
      clear: '明晰',
      back: 'バック',
      reset: 'セットし直す',
      enable: '有効にする',
      on: 'オン',
      off: 'オフ',
      edit: '編集する',
      modify: 'モディファイ',
      remove: '除去する',
      copy: 'コピーする',
      download: 'ダウンロード'
    },

    // Errors messages.
    errors: {
      _default  : (field: any) => `${up(field)}の値が不正です`,
      alpha     : (field: any) => `${up(field)}はアルファベットのみ使用できます`,
      alpha_num : (field: any) => `${up(field)}は英数字のみ使用できます`,
      confirmed : (field: any) => `${up(field)}が一致しません`,
      email     : (field: any) => `${up(field)}は有効なメールアドレスではありません`,
      max       : (field: any, [length]: any) => `${up(field)}は${length}文字以内にしてください`,
      min       : (field: any, [length]: any) => `${up(field)}は${length}文字以上でなければなりません`,
      required  : (field: any) => `${up(field)}は必須項目です`
    }
  }
}